// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"02797eb5","154":"ab4855a9","168":"ab4855a9","245":"ab4855a9","306":"ab4855a9","367":"ab4855a9","415":"ab4855a9","989":"ab4855a9"}[chunkId] + ".chunk.css";
};